<ng-container *ngLet="breakPointObserve$ | async as screenRes">
  <button
    [style.justify-content]="!filterEmpty ? 'end' : 'center'"
    class="btn-empty filter-menu border-circle"
    [class.active]="isOpenSearchColumn"
    (click)="openFilterMenu()"
    matTooltip="{{ 'OTHER.FILTER' | translate }}"
  >
    <app-hoverable-svg [icon]="icons.Filter" cdkOverlayOrigin #searchColumnsTrigger="cdkOverlayOrigin" class="svg24 dark-gray-color"></app-hoverable-svg>
    @if (!filterEmpty) {
      <div class="circle"></div>
    }
  </button>

  <button class="btn-empty filter-modal" [class.not-border]="!hasBorder" (click)="openModal()">
    <svg [icon]="icons.Filter" class="svg24 dark-gray-color" />
    @if (!filterEmpty) {
      <div class="circle"></div>
    }
  </button>

  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayPositions]="overlayPosition"
    [cdkConnectedOverlayOrigin]="searchColumnsTrigger"
    [cdkConnectedOverlayOpen]="isOpenSearchColumn"
    [cdkConnectedOverlayHasBackdrop]="true"
    [cdkConnectedOverlayBackdropClass]="'cdk-overlay-transparent-backdrop'"
    (backdropClick)="isOpenSearchColumn = !isOpenSearchColumn; setDefaultZIndexModal()"
  >
    <ng-container *ngTemplateOutlet="filterTemp"></ng-container>
  </ng-template>

  <ng-template #filterTemp>
    <div [style.height]="screenRes ? 'calc(100% - 48px)' : ''" class="filter-column-container" (keyup.enter)="confirmFilter()">
      <div class="title">
        <span class="h3">{{ 'OTHER.FILTER' | translate }}</span>
        <button class="btn-empty" (click)="closeModal()">
          <svg [icon]="icons.Close" class="dark-gray-color svg24 close-icon" />
        </button>
      </div>
      <div (scroll)="onElementScroll()" class="container">
        <div class="top-menu-filter">
          <mat-checkbox class="recommended" [(ngModel)]="isRecommendationData">{{
            'DATA.CATALOG_ITEMS_DATA.HEADER.RECOMMENDED' | translate
          }}</mat-checkbox>

          @if (selectCatalog?.hasGeo) {
            <div [formGroup]="form"class="container__next-me">
              <mat-checkbox formControlName="isNextMeData">{{ 'DATA.CATALOG_ITEMS_DATA.HEADER.NEARBY' | translate }}</mat-checkbox>
              <div class="input__container">
                <input formControlName="radius"
                       type="number"
                       appPreventScroll
                       class="input__next-me"
                       placeholder="2000"
                />
                <div class="buttons-wrapper">
                  <button [disabled]="!form.controls.isNextMeData.value" class="btn-empty search-btn">
                    <svg [icon]="icons.Search" class="svg24 inactive-color search-icon" />
                  </button>
                </div>
              </div>
            </div>
          }
        </div>

        @for (field of allFilterFields; track $index) {
          <div class="container-item">
            @switch (field.type) {
              @case (dictionaryType) {
                <ng-container>
                  @if (dictionaryOptions?.[field.dictionaryId!]?.length && dictionaryOptions?.[field.dictionaryId!]!.length < 1000) {
                    <app-multi-select-with-input
                      [floatingRuTitle]="field.title"
                      [options]="dictionaryOptions[field.dictionaryId!]"
                      [formControl]="selectedOptionFilters.controls[field.name]"
                      [dropdownWidth]="isMobile ? 320 : 492"
                      [optionHeight]="35"
                      [maxDropdownHeight]="200"
                      [isSearchFilter]="true"
                    ></app-multi-select-with-input>
                  } @else {
                    <app-select
                      #appSelect
                      (selectedValue)="field.searchValue = $event?.toString() ?? ''"
                      [value]="field.searchValue"
                      [selectOptions]="field?.dictionaryValues ?? []"
                      [placeholder]="field.title"
                    >
                    </app-select>
                  }
                </ng-container>
              }

              @case (flagType) {
                <app-select
                  #appSelect
                  (selectedValue)="field.searchValue = $event?.toString() ?? ''"
                  [value]="field.searchValue"
                  [placeholder]="field.title"
                  [selectOptions]="flagSelectionOptions"
                >
                </app-select>
              }

              @case (numberType) {
                <ng-container *ngTemplateOutlet="clearField; context: { type: 'number', field: field }"> </ng-container>
              }

              @case (integerType) {
                <ng-container *ngTemplateOutlet="clearField; context: { type: 'number', field: field }"> </ng-container>
              }

              @case (numericType) {
                <ng-container *ngTemplateOutlet="clearField; context: { type: 'number', field: field }"> </ng-container>
              }

              @case (dateType) {
                <input
                  [showMaskTyped]="true"
                  [mask]="isDateFieldFocused(field) ? 'd0.M0.0000' : null"
                  [dropSpecialCharacters]="false"
                  type="text"
                  class="column-search custom-input"
                  [placeholder]="field.title"
                  (focus)="onDateFieldFocus(field.name)"
                  (blur)="onDateFieldFocus(null)"
                  [(ngModel)]="field.searchValue"
                />
              }

              @default {
                <ng-container *ngTemplateOutlet="clearField; context: { type: 'text', field: field }"> </ng-container>
              }
            }
          </div>
        }
      </div>
      <div class="footer">
        <button class="btn-secondary medium mr12" (click)="cancelFilter()">{{ 'OTHER.RESET_ALL' | translate }}</button>
        <button class="btn-primary medium" (click)="confirmFilter()">{{ 'OTHER.APPLY' | translate }}</button>
      </div>
    </div>
  </ng-template>
</ng-container>

<ng-template #clearField let-field="field" let-type="type">
  <div class="text-container">
    <input
      #searchInput
      [style.padding]="field.isBigTitle ? '10px 20px' : ''"
      [type]="type"
      appPreventScroll
      class="column-search custom-input"
      [(ngModel)]="field.searchValue"
      [placeholder]="field.title"
    />
    @if (field.searchValue !== '') {
      <button
        [style.bottom]="field.isBigTitle ? '18px' : ''"
        class="btn-empty clear-btn"
        type="button"
        (click)="field.searchValue = ''"
      >
        <svg [icon]="icons.CloseRound" class="svg24"></svg>
      </button>
    }
  </div>
</ng-template>
